export default __webpack_public_path__ + "static/media/editDefault.ad8192f6.svg";